// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"914cdd30","481":"3799cde0","985":"50334515"}[chunkId] + ".chunk.js";
};